export const CLOSEDREPORT_REQUEST = "CLOSEDREPORT_REQUEST";
export const CLOSEDREPORT_SUCCESS = "CLOSEDREPORT_SUCCESS";
export const CLOSEDREPORT_FAILURE = "CLOSEDREPORT_FAILURE";
